import cometTiamat from "../assets/img/gif/comet-tiamat.gif";
import emotionalReunion from "../assets/img/gif/emotional-reunion.gif";
import missedEachOther from "../assets/img/gif/missed-each-other.gif";
import mitsuhaBoobGrab from "../assets/img/gif/mitsuha-boob-grab.gif";
import mitsuhaRunning from "../assets/img/gif/mitsuha-running.gif";
import mitsuhaSmile from "../assets/img/gif/mitsuha-smile.gif";
import mitsuhaUntiesHair from "../assets/img/gif/mitsuha-unties-hair.gif";
import takiLunch from "../assets/img/gif/taki-lunch.gif";
const scoreIntervals = [
  {
    min: 0,
    max: 0,
    background: missedEachOther,
  },
  {
    min: 100,
    max: 500,
    background: cometTiamat,
  },
  {
    min: 600,
    max: 1000,
    background: takiLunch,
  },
  {
    min: 1100,
    max: 2000,
    background: mitsuhaSmile,
  },
  {
    min: 2100,
    max: 3000,
    background: mitsuhaRunning,
  },
  {
    min: 3100,
    max: 4000,
    background: mitsuhaUntiesHair,
  },
  {
    min: 4100,
    max: 5000,
    background: emotionalReunion,
  },
  {
    min: 5100,
    max: Number.MAX_SAFE_INTEGER,
    background: mitsuhaBoobGrab,
  },
];

export default scoreIntervals